import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

export default function ImpressumPage() {
  return (
    <>
      <title>Impressum – SPDB Studio Zürich</title>
      <meta name="robots" content="noindex, nofollow" />
      <main className="min-h-screen bg-white">
        <Navbar />

        <section className="pt-48 pb-16 px-8 lg:px-16 bg-warm-white">
          <div className="max-w-2xl mx-auto text-center">
            <p className="section-label mb-6">Rechtliches</p>
            <h1 className="font-serif text-5xl text-text-primary font-medium leading-tight mb-6">Impressum</h1>
            <span className="gold-divider mb-8" />
            <p className="font-sans font-light text-text-secondary text-sm leading-relaxed">
              Gemäss Art. 10 UWG (Schweiz) – gesetzlich vorgeschrieben für geschäftsmässige Webseiten
            </p>
          </div>
        </section>

        <section className="py-24 px-8 lg:px-16">
          <div className="max-w-2xl mx-auto flex flex-col gap-14">

            {/* Herausgeber */}
            <div>
              <h2 className="font-serif text-2xl text-text-primary font-medium mb-6">Herausgeber und Kontakt</h2>
              <div className="flex flex-col gap-4 font-sans font-light text-text-secondary text-sm leading-relaxed">
                <div>
                  <p className="text-xs tracking-luxury font-sans text-text-muted uppercase mb-1">Firmenname</p>
                  <p className="text-text-primary font-medium">SPDB Studio</p>
                </div>
                <div>
                  <p className="text-xs tracking-luxury font-sans text-text-muted uppercase mb-1">Inhaber</p>
                  <p>Denis Plüss</p>
                </div>
                <div>
                  <p className="text-xs tracking-luxury font-sans text-text-muted uppercase mb-1">Adresse</p>
                  <p>
                    [Strasse und Hausnummer]<br />
                    [PLZ] [Ort]<br />
                    Schweiz
                  </p>
                </div>
                <div>
                  <p className="text-xs tracking-luxury font-sans text-text-muted uppercase mb-1">Unternehmens-Identifikationsnummer (UID)</p>
                  <p>CHE-176.264.081</p>
                </div>
              </div>
            </div>

            <div className="h-px bg-light-gray" />

            {/* Kontakt */}
            <div>
              <h2 className="font-serif text-2xl text-text-primary font-medium mb-6">Kontakt</h2>
              <div className="flex flex-col gap-3 font-sans font-light text-text-secondary text-sm leading-relaxed">
                <div className="flex items-start gap-3">
                  <i className="ri-mail-line text-gold mt-0.5" />
                  <a href="mailto:studio@sbdm-studio.ch" className="hover:text-gold transition-colors duration-300">studio@sbdm-studio.ch</a>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-phone-line text-gold mt-0.5" />
                  <a href="tel:+41766827078" className="hover:text-gold transition-colors duration-300">+41 76 682 70 78</a>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-global-line text-gold mt-0.5" />
                  <a href="https://[Deine-Domain].ch" target="_blank" rel="noopener noreferrer nofollow" className="hover:text-gold transition-colors duration-300">[Deine-Domain].ch</a>
                </div>
              </div>
            </div>

            <div className="h-px bg-light-gray" />

            {/* Verantwortliche Person */}
            <div>
              <h2 className="font-serif text-2xl text-text-primary font-medium mb-6">Verantwortliche Person</h2>
              <p className="font-sans font-light text-text-secondary text-sm leading-relaxed">
                Denis Plüss, Inhaber<br />
                SPDB Studio<br />
                [Strasse und Hausnummer], [PLZ] [Ort], Schweiz
              </p>
            </div>

            <div className="h-px bg-light-gray" />

            {/* Haftungsausschluss */}
            <div>
              <h2 className="font-serif text-2xl text-text-primary font-medium mb-6">Haftungsausschluss</h2>
              <p className="font-sans font-light text-text-secondary text-sm leading-relaxed mb-4">
                SPDB Studio übernimmt keine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der auf dieser Website zur Verfügung gestellten Informationen. Haftungsansprüche gegen SPDB Studio wegen Schäden materieller oder immaterieller Art, die aus dem Zugriff oder der Nutzung dieser Webseite entstanden sind, werden ausgeschlossen.
              </p>
              <p className="font-sans font-light text-text-secondary text-sm leading-relaxed">
                Alle Angebote sind freibleibend. SPDB Studio behält sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen oder zu löschen.
              </p>
            </div>

            <div className="h-px bg-light-gray" />

            {/* Urheberrecht */}
            <div>
              <h2 className="font-serif text-2xl text-text-primary font-medium mb-6">Urheberrecht</h2>
              <p className="font-sans font-light text-text-secondary text-sm leading-relaxed">
                Die auf dieser Website veröffentlichten Inhalte unterliegen dem Schweizer Urheberrecht. Jede vom Urheberrecht nicht zugelassene Verwertung bedarf der vorherigen schriftlichen Zustimmung von SPDB Studio. Dies gilt insbesondere für Vervielfältigung, Bearbeitung, Übersetzung, Einspeicherung sowie Verarbeitung und Wiedergabe von Inhalten in Datenbanken oder anderen elektronischen Medien und Systemen.
              </p>
            </div>

            <div className="mt-4">
              <Link to="/datenschutz" className="inline-flex items-center gap-2 text-xs tracking-luxury font-sans text-gold uppercase hover:opacity-70 transition-opacity duration-300">
                <i className="ri-arrow-right-line" />
                Datenschutzerklärung lesen
              </Link>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}
